import {GlobalEvent} from "./utils/event";

/**
 * This class contains different system-wide events as static properties
 */
export class GlobalEvents {
	/** @type {GlobalEvent} */
	static USER_LOGGED_IN = new GlobalEvent('USER_LOGGED_IN');
}



// WEBPACK FOOTER //
// ./core/events.js